export const CTV_KEY = {
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    AD: 'AD',
    BACK: 'BACK',
    BLUE: 'BLUE',
    CHANNEL_DOWN: 'CHANNEL_DOWN',
    CHANNEL_PREV: 'CHANNEL_PREV',
    CHANNEL_UP: 'CHANNEL_UP',
    DELETE: 'DELETE',
    DOWN: 'DOWN',
    ENTER: 'ENTER',
    EXIT: 'EXIT',
    FF: 'FF',
    GREEN: 'GREEN',
    HELP: 'HELP',
    INFO: 'INFO',
    INSTANT_REPLAY: 'INSTANT_REPLAY',
    L3: 'L3',
    LEFT: 'LEFT',
    PAUSE: 'PAUSE',
    PLAY: 'PLAY',
    PLAY_PAUSE: 'PLAY_PAUSE',
    RED: 'RED',
    RIGHT: 'RIGHT',
    RW: 'RW',
    SEARCH: 'SEARCH',
    SHORTCUT_1: 'SHORTCUT_1',
    SHORTCUT_2: 'SHORTCUT_2',
    SHORTCUT_3: 'SHORTCUT_3',
    SHORTCUT_4: 'SHORTCUT_4',
    SHORTCUT_5: 'SHORTCUT_5',
    SHORTCUT_6: 'SHORTCUT_6',
    SHORTCUT_7: 'SHORTCUT_7',
    SHORTCUT_8: 'SHORTCUT_8',
    SHORTCUT_9: 'SHORTCUT_9',
    SKIP_NEXT: 'SKIP_NEXT',
    SKIP_PREV: 'SKIP_PREV',
    START: 'START',
    STOP: 'STOP',
    SUBTITLES: 'SUBTITLES',
    UNKNOWN: 'UNKNOWN',
    UP: 'UP',
    Y: 'Y',
    YELLOW: 'YELLOW',
};
export function lookupCTVKeysForKeyCode(keyMap, key) {
    const keySymbols = [];
    // eslint-disable-next-line guard-for-in
    for (const ctvKey in keyMap) {
        const nativeKeyCodes = keyMap[ctvKey];
        if (nativeKeyCodes.indexOf(key) !== -1) {
            keySymbols.push(ctvKey);
        }
    }
    if (keySymbols.length === 0) {
        keySymbols.push(CTV_KEY.UNKNOWN);
    }
    return keySymbols;
}
//# sourceMappingURL=ctv-input.js.map